export default "__VITE_ASSET__DIpIZ7qH__"